/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/iframe-has-title */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./App.css";
import { faMapPin, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

function App() {

  return (
    <>
      <header className="fade-in">
        <a href="#main">
          <img src="./logo.png" alt="logo" />
        </a>
        <div className="nav">
          <a href="#about">Quem somos</a>
          <a href="#services">Eventos</a>
          <a href="#contacts">Contactos</a>
        </div>
      </header>
      <div className="main fade-in" id="main">
        <div className="slides">
          <div className="slide slide-1">
            <div className="background fade-in-image" style={{ backgroundImage: "url(./background.jpeg)" }} />
            <div className="content">
              <h1>Está à espera do quê?</h1>
              <p>Dê o passo e fale connosco</p>
            </div>
          </div>
        </div>
        <div className="about fade-in" id="about">
          <div className="background-effect" />
          <div className="container">
            <div className="text">
              <h1>Quem somos</h1>
              <p>Num mundo onde se acredita que nada se cria e tudo se copia, CAOS surge da necessidade de encontrar um nome que refletisse em si cinco jovens com uma vontade insaciável de tentar criar sempre a melhor versão dos projetos em que se envolvem.  Acreditando, no fundo, que ainda existem coisas por criar e que num mundo cheio de possibilidades, não nos devemos contentar com o básico. “Em tradições mitológicas, CAOS significa o princípio de criatividade e de possibilidades infinitas.” Caos não significa a falta de confiança ou de organização, simboliza para nós um infinito de oportunidades originais que estão à espera que as aproveitemos para os vossos eventos.</p>
              <br />
              <p>Se todos os eventos partem de um caos de ideias e objetivos, então a nossa arte é encontrar as peças perfeitas para cada evento, sejam fornecedores, espaços ou caterings, passando-as do rascunho para a realidade. Proporcionamos experiências memoráveis e fora da caixa tal como o nosso nome indica. </p>
              <br />
              <p>Cada evento é especial e a nossa agência visa em usar a criatividade para os tornar em histórias únicas que reflitam os nossos clientes.</p>
              <br />
              <p>É assim que um grupo de jovens empreendedoras fundou a CAOS, uma empresa que olha para a organização de eventos enquanto uma arte, procurando proporcionar as melhores e mais criativas experiências nos projetos onde se envolvem.</p>
            </div>
            <img src="/icon.png" alt="about" />
          </div>
        </div>
        <div className="services fade-in" id="services">
          <div className="container">
            <div className="title">
              <h1>Eventos</h1>
              <p>Isto é o que fazemos e no que somos bons!</p>
            </div>
            <div className="cards">
              <div className="card">
                <h3>Corporate</h3>
                <div className="divider" />
                <p>A CAOS, especializa-se em eventos corporate que vão além das expectativas. Desde conferências dinâmicas e workshops interativos até aos lançamentos de produtos inovadores.</p>
                <p>A nossa equipa trabalha de forma a criar experiências impactantes, transformamos ideias em realidade, garantindo que seu evento seja único, envolvente e profissional.</p>
              </div>
              <div className="card">
                <h3>Caridade e Sustentabilidade</h3>
                <div className="divider" />
                <p>Na CAOS, acreditamos no poder dos eventos de forma a criar um impacto social.</p>
                <p>Organizamos leilões e eventos para angariação de fundos monetários que simultaneamente aumentam a conscientização para causas humanitárias importantes.</p>
                <p>Além disso, a nossa abordagem sustentável reflete-se em eventos eco-friendly, workshops educativos e iniciativas comunitárias, demonstrando o nosso compromisso para um mundo mais sustentável.</p>
              </div>
              <div className="card">
                <h3>Sociais</h3>
                <div className="divider" />
                <p>Seja um casamento íntimo, uma festa de aniversário extravagante ou uma celebração especial, a nossa equipa vai tornar as suas ideias e expetativas em realidade.</p>
                <p>Todos os pormenores são planeados ao detalhe, desde a decoração até à seleção gastronómica, de forma a garantir que o evento seja inesquecível tanto para o cliente como para os convidados.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="contacts fade-in" id="contacts">
          <div className="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24889.241528094786!2d-9.2317381256836!3d38.76014440000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ecd2d8b2ed74b%3A0x202b4b75d4efd2ef!2sEuropean%20University%20of%20Lisbon!5e0!3m2!1sen!2spt!4v1699806699880!5m2!1sen!2spt" width="100%" height="400" style={{border:0}} allowFullScreen aria-hidden="false"></iframe>
          </div>
          <div className="container">
            <div className="title">
              <h1>Contactos</h1>
              <p>Quer falar connosco? Estamos à sua espera.</p>
            </div>
            <div className="text">
              <br />
              <p><FontAwesomeIcon icon={faMapPin} className="icon"/> Quinta do Bom Nome, Estr. da Correia 53, 1500-210 Lisboa</p>
              <p><FontAwesomeIcon icon={faPhone} className="icon"/> +351 924 314 523</p>
              <p><FontAwesomeIcon icon={faEnvelope} className="icon"/> <a href="mailto:caoseventos@gmail.com" target="_blank">caoseventos@gmail.com</a></p>
              <p><FontAwesomeIcon icon={faInstagram} className="icon"/> <a href="https://www.instagram.com/caoseeventos" target="_blank">@caoseeventos</a></p>
              <br />
              <br />
              <br />
              <p>Aguardamos o seu contacto!</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
